'use client';
import { getWechatJSConfig } from '@/app/services/wechat';
import { siteConfig } from '@/config/site';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const WxShare = ({
  title,
  desc,
  link,
  image,
}: {
  title?: string;
  desc?: string;
  link?: string;
  image?: string;
}) => {
  const pathname = usePathname();
  const initJSSDK = async () => {
    const url = link || location.href;
    const { data } = await getWechatJSConfig(url);
    window.wx?.config({
      debug: false, // 开启调试模式
      appId: data.appId, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
    });

    window.wx?.ready(function () {
      const shareConfig = {
        title: title || siteConfig.name,
        desc: desc || siteConfig.description,
        link: encodeURI(url),
        imgUrl: image || location.origin + '/logo.svg',
      };
      window.wx?.updateAppMessageShareData(shareConfig);
      window.wx?.updateTimelineShareData(shareConfig);
    });
    // window.wx?.error(function (res) {
    //   alert(JSON.stringify(res));
    // });
  };

  useEffect(() => {
    if (window.wx) {
      initJSSDK();
    }
  }, [pathname]);

  return <div></div>;
};

export default WxShare;
